import { IconName } from "../../shared/components/Icon";
import { PATHS } from "../../paths";

export interface Training {
  path: string;
  icon: IconName;
  cardTitle: string;
  title: string;
  seoDescription: string;
  intro: string;
  steps?: string[];
  videoId?: string;
}

export const TRAININGS: Training[] = [
  {
    path: PATHS.trainingFireBehaviour,
    icon: "flame",
    cardTitle: "Yangında Davranış Şekilleri",
    title: "Yangında Davranış Şekilleri Simülasyonu",
    seoDescription:
      "Etkileşimli sanal gerçeklik simülasyonu ile yangın tüpü kullanımını ve yangın anında yapılması gerekenleri öğreten Securitas İtfaiye eğitimi.",
    intro:
      "İtfaiye hizmetleri kapsamında bir ilk olan “Etkileşimli Sanal Gerçeklik Simülasyonu İtfaiye Eğitimi” önceden hazırlanmış senaryolar aracılığıyla yangın tüpü kullanımını ve yangın anında yapılması gerekenleri en etkili şekilde öğretir. Senaryolar, yangın sırasında panik yaşanmadan en doğru müdahalenin yapılmasını hedefler. Eğitim senaryosunun en iyi yöntemlerle ve en az hasarla tamamlanmasını sağlamak için süreçler kayıt altına alınır. Her kayıtta katılımcıların gelişimi gözlemlenerek sürekli iyileştirme sağlanır.",
    videoId: "vLt77lFJYic",
  },
  {
    path: PATHS.trainingTheory,
    icon: "extinguisher",
    cardTitle: "Teorik ve Uygulamalı Yangın Eğitimi",
    title: "Teorik ve Uygulamalı Yangın Eğitimi",
    seoDescription:
      "Securitas İtfaiye Hizmetleri'nin işletmenin İSG kurallarına uygun olarak düzenlediği teorik ve uygulamalı yangın eğitimleri.",
    intro:
      "Securitas İtfaiye Hizmetleri, güçlü eğitim kadrosu ve ekipmanlarıyla işletme tarafından belirlenen İSG kurallarına ve işletme gerekliliklerine uygun olarak Teorik ve Uygulamalı Yangın Eğitimleri düzenler. Farklı sektörlerin ihtiyaç analizleri doğrultusunda itfaiye görevlilerinin yetişmesi sağlanır.",
    steps: [
      "Acil Durum Hallerinde Hareket Tarzları",
      "Yangın Güvenliğine İlişkin Azami Bilgiler",
      "Model Eğitimleri ve Performansa Dayalı Değerlendirme",
    ],
    videoId: "f-LBgvoTZ6s",
  },
  {
    path: PATHS.trainingAdvanced,
    icon: "ladder",
    cardTitle: "İleri Seviye Ateşli İtfaiye Eğitimi",
    title: "İleri Seviye Ateşli İtfaiye Eğitimi",
    seoDescription:
      "Temel yangın eğitimini tamamlayan personelin yangın öncesinde, anında ve sonrasında alacağı aksiyonları öğrendiği İleri Seviye Ateşli İtfaiye Eğitimi.",
    intro:
      "Teorik ve Uygulamalı Temel Yangın Eğitimi'ni alan personel, bu eğitimden sonra İleri Seviye Ateşli İtfaiye Eğitimi'ni alır. Eğitimde yangın öncesinde, anında ve sonrasında alacağı aksiyonları etkin bir şekilde öğrenir.",
    videoId: "4XxcLzosXNU",
  },
];
